<template>
    <div class="subsequent-cards col-12">
        <h3 class="mb-4 mt-4 pb-2 w-100 text-center color--blue-7">
            Laatst toegevoegde activiteiten
        </h3>

        <div ref="sliderInside" class="activities-inside__slider row">
            <activity-card
                v-for="activity in activities"
                :key="activity.id"
                class="mb-2 col-12 col-sm-6 col-md-3"
                :activity="activity"
            ></activity-card>
        </div>
    </div>
</template>
<script>
import Axios from 'axios';
import activityCard from '@/components/cards/activity-card';

export default {
    components: {
        activityCard
    },
    data() {
        return {
            activities: []
        };
    },
    created() {
        this.getLatestActivities();
    },
    methods: {
        getLatestActivities() {
            Axios.get('/api/activity/latestactivities')
                .then(response => {
                    this.activities = response.data;

                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>
<style></style>
